module.exports = __webpack_public_path__ + "static/media/res.412ae1ec.png";